import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {DateTime, Duration} from 'luxon';
import {ColorConstants} from '../../../common/colors-variables.generated';
import {ScheduleItem} from '../schedule-item.interface';
import {TimelineRowService} from '../timeline-row/timeline-row.service';

@Component({
  selector: 'vdw-schedule-item',
  templateUrl: './schedule-item.component.html',
  styleUrls: ['./schedule-item.component.scss']
})
export class ScheduleItemComponent implements OnInit {
  @Input() public scheduleItem: ScheduleItem;
  @Input() public isPastDay: boolean;
  @Input() public isCurrentDay: boolean;
  @Input() public isSelected: boolean;
  @Output() public deleteEvent = new EventEmitter<void>();
  @Output() public checkboxEvent = new EventEmitter<void>();

  public startDateTime: DateTime;
  public endDateTime: DateTime;
  public backgroundColor = '';
  public borderColor = '';
  public boxShadow = '';
  public breaks: {left: number; width: number}[] = [];
  private readonly PADDING = 2;

  public constructor(private readonly timelineRowService: TimelineRowService) {}

  public ngOnInit(): void {
    const currentDate = DateTime.now().startOf('day');
    this.startDateTime = currentDate.plus({days: this.scheduleItem.startTime.days, hours: this.scheduleItem.startTime.hours, minutes: this.scheduleItem.startTime.minutes});
    this.endDateTime = currentDate.plus({days: this.scheduleItem.endTime.days, hours: this.scheduleItem.endTime.hours, minutes: this.scheduleItem.endTime.minutes});
    this.updateColors();
    this.setBreaks();
  }

  public valueChanged(matCheckboxChange: MatCheckboxChange): void {
    this.scheduleItem.selected = matCheckboxChange.checked;
    this.checkboxEvent.emit();
  }

  private updateColors(): void {
    this.backgroundColor = this.isPastDay || this.hasShiftStarted() ? ColorConstants.NEUTRAL_900 : ColorConstants[`${this.scheduleItem.color}_900`];
    this.borderColor = this.isPastDay || this.hasShiftStarted() ? ColorConstants.NEUTRAL_700 : ColorConstants[`${this.scheduleItem.color}_500`];
    this.boxShadow = this.isPastDay || this.hasShiftStarted() ? 'none' : '0 0 3px 0 ' + ColorConstants.TINT_NEUTRAL_BLACK_30_TRANSPARENT;
  }

  private hasShiftStarted(): boolean {
    if (this.isCurrentDay) {
      const gap = this.startDateTime.diff(DateTime.now(), 'minutes').minutes;
      return gap <= 0;
    }
    return false;
  }

  private setBreaks(): void {
    this.scheduleItem.breaks.forEach((data: {id: number | string; startTime: Duration; duration: number}) => {
      this.breaks.push({
        left: this.timelineRowService.calculateWidth(this.scheduleItem.startTime, data.startTime, false) - this.PADDING,
        width: this.timelineRowService.calculateWidthFromMinutes(data.duration)
      });
    });
  }
}
